module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/IceDay/Nagano_IceDay_MRI_RCP85_End.png";